import { useEffect, useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { api } from "@/lib/api";
import { AdminReports } from "@/components/admin/AdminReports";
import { AdminUsers } from "@/components/admin/AdminUsers";
import { AdminEvents } from "@/components/admin/AdminEvents";

const STATS = [
  ["open_reports", "Segnalazioni aperte"], ["hostesses", "Hostess"], ["clients", "Clienti"], ["open_events", "Eventi aperti"],
  ["unlocks", "Contatti sbloccati"], ["credits_sold", "Crediti venduti"], ["revenue", "Incassi €"], ["hidden_hostesses", "Profili nascosti"],
];

const tabCls = "rounded-none text-xs uppercase tracking-[0.15em] data-[state=active]:bg-[#D4AF37] data-[state=active]:text-[#0B0C0E]";

export default function AdminPage() {
  const [stats, setStats] = useState(null);
  const loadStats = () => api.get("/admin/stats").then((r) => setStats(r.data));
  useEffect(() => { loadStats(); }, []);

  return (
    <main className="max-w-7xl mx-auto px-6 lg:px-10 pt-16" data-testid="admin-page">
      <p className="eyebrow">Amministrazione</p>
      <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl mt-3">Pannello admin</h1>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-white/5 border border-white/5 mt-10" data-testid="admin-stats">
        {STATS.map(([k, l]) => (
          <div key={k} className="bg-[#0B0C0E] p-6">
            <p className="text-[11px] uppercase tracking-[0.15em] text-neutral-500">{l}</p>
            <p className={`font-serif text-4xl mt-2 ${k === "open_reports" && stats?.[k] ? "text-red-400" : ""}`} data-testid={`admin-stat-${k}`}>{stats ? stats[k] : "–"}</p>
          </div>
        ))}
      </div>
      <Tabs defaultValue="reports" className="mt-12">
        <TabsList className="bg-[#121418] border border-white/10 rounded-none h-auto p-1 flex-wrap">
          <TabsTrigger value="reports" className={tabCls} data-testid="admin-tab-reports">Segnalazioni</TabsTrigger>
          <TabsTrigger value="users" className={tabCls} data-testid="admin-tab-users">Utenti</TabsTrigger>
          <TabsTrigger value="events" className={tabCls} data-testid="admin-tab-events">Eventi</TabsTrigger>
        </TabsList>
        <TabsContent value="reports"><AdminReports onChange={loadStats} /></TabsContent>
        <TabsContent value="users"><AdminUsers onChange={loadStats} /></TabsContent>
        <TabsContent value="events"><AdminEvents onChange={loadStats} /></TabsContent>
      </Tabs>
    </main>
  );
}
